















































import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop, Watch} from 'vue-property-decorator';
import {challengeModule, timelineRepliesState, userModule} from '@/utils/store-acessor';
import {TimelineReplyModel} from '@/models/timeline.model';
import {ChallengeModel} from '@/models/challenge.model';
import {UserModel} from '@/models/user.model';
import {validators} from '@/utils/validations';
import SendButton from '@/components/Shared/buttons/SendButton.vue';
import DeleteButton from '@/components/Shared/buttons/DeleteButton.vue';
import EditButton from '@/components/Shared/buttons/EditButton.vue';

@Component({
  components: {EditButton, DeleteButton, SendButton}
})
export default class ReplyForm extends Vue {
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @Prop({required: false}) reply!: TimelineReplyModel;
  @Prop({required: true}) interactionId!: number;
  @Prop({required: true}) timelineId!: number;
  @Prop({required: true, default: false}) alreadyReplied!: boolean;
  @userModule.Getter('user') user!: UserModel;
  rules = validators;
  loading = false;
  snackbarColor: 'green' | 'red' = 'green';
  snackbarMessage: string = '';
  snackbarVisibility = false;
  hasReplyFromCurrentUser = true;
  destroyLoader = false;
  replyModel = new TimelineReplyModel();
  showForm = false;

  get isMyReply(): boolean {
    return this.replyModel?.user_id == this.user?.id
  }

  @Watch('reply', {deep: true, immediate: true})
  onReplyChange(newValue: TimelineReplyModel) {
    if (!!newValue) {
      this.replyModel = {...newValue}
    } else {
      this.replyModel = new TimelineReplyModel()
    }
  }

  async onSendInteraction() {
    if (this.challenge?.id) {
      try {
        this.loading = true;
        if (!this.reply?.id) {
          await timelineRepliesState.createReply({
            challengeId: this.challenge.id,
            timelineId: this.timelineId,
            interactionId: this.interactionId,
            payload: this.replyModel
          });
        } else {
          await timelineRepliesState.editReply({
            challengeId: this.challenge.id,
            timelineId: this.timelineId,
            interactionId: this.interactionId,
            payload: this.replyModel
          })
        }
        this.successToSendInteraction();
        this.hasReplyFromCurrentUser = true;
        this.showForm = false;
        this.successToReply();
      } catch (e) {
        this.failedToSendInteraction();
      } finally {
        this.loading = false;
      }
    }
  }

  async onDeleteInteraction() {
    this.snackbarVisibility = false;
    if (this.challenge?.id && this.replyModel?.id) {
      this.destroyLoader = true;
      try {
        await timelineRepliesState.deleteReply({
          interactionId: this.interactionId,
          challengeId: this.challenge.id,
          timelineId: this.timelineId,
          replyId: this.replyModel.id
        });
        this.onToastMessage('timeline.messages.interaction_deleted', 'green');
        this.replyModel = new TimelineReplyModel();
      } catch (e) {
        this.onToastMessage('timeline.messages.interaction_deleted_error', 'red')
      } finally {
        this.destroyLoader = false;
      }
    }
  }

  failedToSendInteraction() {
    this.onToastMessage('timeline.messages.reply_registered_error', 'red')
  }

  successToSendInteraction() {
    this.onToastMessage('timeline.messages.reply_registered', 'green')
  }

  @Emit()
  successToReply() {
    return;
  }

  editReply(reply: TimelineReplyModel) {
    this.replyModel = reply;
    this.showForm = !this.showForm;
  }

  private onToastMessage(message: string, color: 'green' | 'red') {
    this.snackbarColor = color;
    this.snackbarVisibility = true;
    this.snackbarMessage = message;
  }
}
